import ApiService from '@/service/ApiService';

let moduleApi = {};
let moduleName = "profile";


moduleApi.list = async (dataFilter,loading) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter,
        dontLoading: (loading == undefined ? false : loading ),
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id,loading) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id },
        message: {
            success: "hidden",
            error: "hidden"
        },
        dontLoading: (loading == undefined ? false : loading ),
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
    let api = {
      module: moduleName,
      type: "partialUpdate",
      value: dataForm,
      message: {
          success: "hidden",
          error: "hidden"
      }
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.create = async (dataForm) => {
    let api = {
      module: moduleName,
      type: "create",
      value: dataForm,
      message: {
          success: "hidden",
          error: "hidden"
      }
    };
    
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};


export default moduleApi;